<fuse-widget class="widget p-0 h-100-p" fxLayout="column">

    <!-- Front -->
    <div class="fuse-widget-front mat-white-bg mat-elevation-z2 h-100-p" fxLayout="column" fxLayoutAlign="stretch stretch">

        <div class="px-16 py-8 border-bottom widget-header title-bar mat-accent-bg" fxLayout="row"
                    fxLayoutAlign="space-between center">
            <div class="mat-accent-bg" fxLayout="row" fxLayoutAlign="start center">
                <div class="h3 title pr-4">{{title}}</div>
                <div *ngIf="data?.length>0" fxLayout="row" fxLayoutAlign="start center">
                    <div class="h3 secondary">({{data?.length}})</div>
                </div>
            </div>
            <button *ngIf="allowAdd" mat-icon-button aria-label="Add" class="mat-icon-button" (click)="add()" matTooltip="Add Assessment">
                <mat-icon class="mat-accent-bg">add</mat-icon>
            </button>
        </div>

        <div *ngIf="data?.length === 0" fxLayout="column" fxLayoutAlign="center center" fxFlex>
            <span class="mat-h1 hint-text py-48">There are no assessments</span>
        </div> 

        <div *ngIf="data?.length>0" class="data-list">
            <div class="p-16 clickable row list-item" *ngFor="let row of data; trackBy: trackById" (click)="select(row);" (dblclick)="viewOrEdit(row);" [ngClass]="{'selected':row?.id == selected?.id}">
                <div fxLayout="row" fxLayoutAlign="space-between center">
                    <div fxLayout="row" fxLayoutAlign="space-between center" style="flex-grow:1">
                        <div fxLayout="row" fxLayoutAlign="start center">
                            <div class="status {{row.class}}">{{row.score}} / {{row.threshold}}</div>
                            <div class="pl-12" fxLayout="row" fxLayoutAlign="start center">
                                <div>
                                    <div *ngIf="row?.completed" class="h3">{{row.completedDate | dateFormat}} - {{row.templateName}}</div>
                                    <div *ngIf="!row?.completed" class="h3">{{row.templateName}}<span class="in-progress"> - In Progress</span></div>
                                    <div>
                                        <span class="secondary-text">{{row.secondary}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <button *ngIf="(!allowEdit || !hasSubjectUserEditPrivs) || row.completed" mat-icon-button aria-label="View Details" class="mat-icon-button" matTooltip="View Details" (click)="view(row);">
                        <mat-icon>open_in_browser</mat-icon>
                    </button>
                    <div *ngIf="allowEdit && hasSubjectUserEditPrivs && (!row.completed)" >
                        <button mat-icon-button class="mat-icon-button" style="margin-right:-8px;" id="btnEdit" aria-label="Edit" matTooltip="Edit" (click)="edit(row)"><mat-icon>edit</mat-icon></button>
                        <button mat-icon-button class="mat-icon-button" style="margin-left:-8px;" id="btnDelete" aria-label="Delete" matTooltip="Delete" (click)="delete(row)"><mat-icon>delete</mat-icon></button>
                    </div> 
                </div>
            </div>
        </div>
    </div>


    <!-- / Front -->

</fuse-widget>